import { useAppContext } from '@/contexts/AppContext';
import { APP_ROLE } from '@/services/roleService';
import React from 'react';

export const useGetUseRole = () => {
  let { auth } = useAppContext();

  let isAdmin = React.useMemo(() => {
    return auth?.roles?.includes(APP_ROLE.Admin);
  }, [auth]);
  let isBooking = React.useMemo(() => {
    return auth?.roles?.includes(APP_ROLE.Booking);
  }, [auth]);
  let isReport = React.useMemo(() => {
    return auth?.roles?.includes(APP_ROLE.Report);
  }, [auth]);
  return { isAdmin, isBooking, isReport };
};
